import React from 'react';
import classie from 'classie';

let count = 0;
class DisableBodyScroll extends React.Component {
  UNSAFE_componentWillMount() {
    if (count === 0) {
      classie.add(document.body, 'no-scroll');
    }
    ++count;
  }
  componentWillUnmount() {
    --count;
    if (count === 0) {
      classie.remove(document.body, 'no-scroll');
    }
  }
  render() {
    /* eslint-disable */
    if (this.props.children) {
      return React.Children.only(this.props.children);
    }
    /* eslint-enable */
    return null;
  }
}

export default DisableBodyScroll;



// WEBPACK FOOTER //
// ./spa/Components/DisableBodyScroll.jsx